import { useEffect, useRef } from 'react';
import _ from 'lodash';

const useInterval = (callback, delay) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!_.isFinite(delay) || delay <= 0) {
      return;
    }
    const id = setInterval(() => {
      if (callbackRef.current != null && _.isFunction(callbackRef.current)) {
        callbackRef.current();
      }
    }, delay);
    return () => clearInterval(id);
  }, [delay]);
};

export default useInterval;
